/**
 * Replaces {{ price }} / {{ compare_at_price }} / {{ price_from }} tokens
 * with live price text wherever they show up as plain text on a product
 * page — including content injected by third-party apps (e.g. the
 * "Easy Tabs" product tabs app block) that render their own HTML and never
 * pass through this theme's Liquid, so the server-side replace in
 * main-product.liquid can't reach them.
 */
(function () {
  function getTokenMap() {
    var scripts = document.querySelectorAll('script[type="application/json"][id^="ProductPriceTokens-"]');
    var map = {};
    scripts.forEach(function (script) {
      try {
        var data = JSON.parse(script.textContent);
        Object.keys(data).forEach(function (key) {
          map[key] = data[key];
        });
      } catch (error) {
        // Ignore malformed data from a given section instance.
      }
    });
    return map;
  }

  var tokenMap = getTokenMap();
  var tokens = Object.keys(tokenMap);
  if (!tokens.length) return;

  var pattern = new RegExp(
    tokens.map(function (token) {
      return token.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }).join('|')
  );

  function replaceInTextNode(node) {
    var text = node.nodeValue;
    if (!pattern.test(text)) return;
    tokens.forEach(function (token) {
      if (text.indexOf(token) !== -1) {
        text = text.split(token).join(tokenMap[token]);
      }
    });
    node.nodeValue = text;
  }

  function walk(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node = walker.nextNode();
    while (node) {
      replaceInTextNode(node);
      node = walker.nextNode();
    }
  }

  function run() {
    walk(document.body);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (added) {
          if (added.nodeType === Node.TEXT_NODE) {
            replaceInTextNode(added);
          } else if (added.nodeType === Node.ELEMENT_NODE) {
            walk(added);
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // Apps load their widgets asynchronously but not indefinitely late;
    // stop observing once they've had a reasonable chance to render.
    setTimeout(function () {
      observer.disconnect();
    }, 20000);
  }

  if (document.body) {
    run();
  } else {
    document.addEventListener('DOMContentLoaded', run);
  }
})();
